import React from 'react';

const iconProps = {
  className: 'vmk-warranty-icon',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const s = {
  stroke: '#fff',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const VmkWarrantyProfileIcon = () => (
  <svg {...iconProps}>
    <rect x="5" y="5" width="14" height="14" rx="1" {...s} />
    <path d="M5 12h14M12 5v14" {...s} />
    <path d="M8.5 8.5h7v7h-7z" {...s} />
  </svg>
);

export const VmkWarrantyGlassIcon = () => (
  <svg {...iconProps}>
    <rect x="4" y="4" width="16" height="16" rx="1" {...s} />
    <path d="M4 12h16M12 4v16" {...s} />
  </svg>
);

export const VmkWarrantyHardwareIcon = () => (
  <svg {...iconProps}>
    <path d="M8 16l8-8" {...s} />
    <path d="M9.5 14.5 7 17l1 1 2.5-2.5" {...s} />
    <path d="M14.5 9.5 17 7l-1-1-2.5 2.5" {...s} />
    <path d="M6 18l2-2M16 8l2-2" {...s} />
  </svg>
);

export const VmkWarrantyInstallIcon = () => (
  <svg {...iconProps}>
    <path d="M14.5 6.5l3 3-7 7-4 1 1-4 7-7z" {...s} />
    <path d="M13 8l3 3" {...s} />
    <path d="M5 19l2-2" {...s} />
    <path d="M16 5l3-3" {...s} />
  </svg>
);

export const VmkWarrantySkgIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="8" {...s} />
    <path d="M8.5 12.5 11 15l5-5.5" {...s} />
  </svg>
);

export const VmkWarrantyPkvIcon = () => (
  <svg {...iconProps}>
    <path d="M12 4.5 18 7.5V12c0 4.5-2.8 7.2-6 8.5-3.2-1.3-6-4-6-8.5V7.5L12 4.5z" {...s} />
    <path d="M10 12.5 11.5 14 14.5 10.5" {...s} />
  </svg>
);

export const VMK_WARRANTY_ICONS = [
  VmkWarrantyProfileIcon,
  VmkWarrantyGlassIcon,
  VmkWarrantyHardwareIcon,
  VmkWarrantyInstallIcon,
  VmkWarrantySkgIcon,
  VmkWarrantyPkvIcon,
];
